import { Attachment } from './context';

export enum ChatActionTypes {
  // Threadable Actions
  SET_THREADABLES_LOADING = 'SET_THREADABLES_LOADING',
  SET_THREADABLES_VALIDATING = 'SET_THREADABLES_VALIDATING',
  SET_THREADABLES_DATA = 'SET_THREADABLES_DATA',
  SET_THREADABLES_ERROR = 'SET_THREADABLES_ERROR',
  SET_ACTIVE_THREADABLE = 'SET_ACTIVE_THREADABLE',
  DELETE_THREADABLE = 'DELETE_THREADABLE',

  // Thread Actions
  SET_THREADS_LOADING = 'SET_THREADS_LOADING',
  SET_THREADS_VALIDATING = 'SET_THREADS_VALIDATING',
  SET_THREADS_DATA = 'SET_THREADS_DATA',
  SET_THREADS_ERROR = 'SET_THREADS_ERROR',

  SET_ACTIVE_THREAD = 'SET_ACTIVE_THREAD',

  MARK_THREAD_AS_READ = 'MARK_THREAD_AS_READ',

  DELETE_THREAD = 'DELETE_THREAD',

  // Message Actions
  SET_MESSAGES_LOADING = 'SET_MESSAGES_LOADING',
  SET_MESSAGES_VALIDATING = 'SET_MESSAGES_VALIDATING',
  SET_MESSAGES_DATA = 'SET_MESSAGES_DATA',
  SET_MESSAGES_ERROR = 'SET_MESSAGES_ERROR',

  SEND_MESSAGE_OPTIMISTIC = 'SEND_MESSAGE_OPTIMISTIC',
  SEND_MESSAGE_CONFIRMED = 'SEND_MESSAGE_CONFIRMED',
  SEND_MESSAGE_REVERT = 'SEND_MESSAGE_REVERT',

  HANDLE_MESSAGE_SENT_EVENT = 'HANDLE_MESSAGE_SENT_EVENT',
  HANDLE_MESSAGE_REACTED_TO_EVENT = 'HANDLE_MESSAGE_REACTED_TO_EVENT',

  DELETE_MESSAGE = 'DELETE_MESSAGE',
  EDIT_MESSAGE = 'EDIT_MESSAGE',

  // Reaction Actions
  ADD_REACTION_OPTIMISTIC = 'ADD_REACTION_OPTIMISTIC',
  ADD_REACTION_CONFIRMED = 'ADD_REACTION_CONFIRMED',
  ADD_REACTION_REVERT = 'ADD_REACTION_REVERT',

  REMOVE_REACTION_OPTIMISTIC = 'REMOVE_REACTION_OPTIMISTIC',
  REMOVE_REACTION_CONFIRMED = 'REMOVE_REACTION_CONFIRMED',
  REMOVE_REACTION_REVERT = 'REMOVE_REACTION_REVERT',
}
export interface SetActiveThreadable {
  type: ChatActionTypes.SET_ACTIVE_THREADABLE;
  threadableType: string;
  threadableId: string;
}

export interface SetThreadablesLoading {
  type: ChatActionTypes.SET_THREADABLES_LOADING;
  threadableType: string;
  isLoading: boolean;
}
export interface SetThreadablesValidating {
  type: ChatActionTypes.SET_THREADABLES_VALIDATING;
  threadableType: string;
  isValidating: boolean;
}
export interface SetThreadablesData {
  type: ChatActionTypes.SET_THREADABLES_DATA;
  threadableType: string;
  threadables: (Groupthink.RoomResource | Groupthink.TaskResource | Groupthink.AgendaResource)[];
}
export interface SetThreadablesError {
  type: ChatActionTypes.SET_THREADABLES_ERROR;
  threadableType: string;
  error: Error;
}
export interface DeleteThreadable {
  type: ChatActionTypes.DELETE_THREADABLE;
  payload: {
    threadableType: string;
    threadableId: string;
  };
}

export interface SetThreadsLoading {
  type: ChatActionTypes.SET_THREADS_LOADING;
  threadableId: string;
  isLoading: boolean;
}
export interface SetThreadsValidating {
  type: ChatActionTypes.SET_THREADS_VALIDATING;
  threadableId: string;
  isValidating: boolean;
}
export interface SetThreadsData {
  type: ChatActionTypes.SET_THREADS_DATA;
  threadableId: string;
  threads: Groupthink.ThreadResource[];
  hasMorePages: boolean;
}
export interface SetThreadsError {
  type: ChatActionTypes.SET_THREADS_ERROR;
  threadableId: string;
  error: Error;
}
export interface SetActiveThread {
  type: ChatActionTypes.SET_ACTIVE_THREAD;
  threadId: string | null;
}
export interface DeleteThread {
  type: ChatActionTypes.DELETE_THREAD;
  payload: {
    threadableId: string;
    threadId: string;
  };
}
export interface MarkThreadAsRead {
  type: ChatActionTypes.MARK_THREAD_AS_READ;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
  };
}

export interface SetMessagesLoading {
  type: ChatActionTypes.SET_MESSAGES_LOADING;
  threadId: string;
  isLoading: boolean;
}
export interface SetMessagesValidating {
  type: ChatActionTypes.SET_MESSAGES_VALIDATING;
  threadId: string;
  isValidating: boolean;
}
export interface SetMessagesData {
  type: ChatActionTypes.SET_MESSAGES_DATA;
  threadId: string;
  messages: Groupthink.MessageResource[];
}
export interface SetMessagesError {
  type: ChatActionTypes.SET_MESSAGES_ERROR;
  threadId: string;
  error: Error;
}

export interface SendMessageOptimistic {
  type: ChatActionTypes.SEND_MESSAGE_OPTIMISTIC;
  payload: {
    threadableId: string;
    threadId: string;
    tempId: string;
    content: string;
    attachments: Attachment[];
    user: Groupthink.UserResource;
  };
}
export interface SendMessageConfirmed {
  type: ChatActionTypes.SEND_MESSAGE_CONFIRMED;
  payload: {
    threadableId: string;
    threadId: string;
    tempId: string;
    message: Groupthink.MessageResource;
  };
}
export interface SendMessageRevert {
  type: ChatActionTypes.SEND_MESSAGE_REVERT;
  payload: { threadableId: string; threadId: string; tempId: string };
}

export interface HandleMessageSentEvent {
  type: ChatActionTypes.HANDLE_MESSAGE_SENT_EVENT;
  payload: {
    message: Groupthink.MessageResource;
  };
  user: Groupthink.UserResource;
}
export interface HandleMessageReactedToEvent {
  type: ChatActionTypes.HANDLE_MESSAGE_REACTED_TO_EVENT;
  payload: {
    message: Groupthink.MessageResource;
  };
}

export interface AddReactionOptimistic {
  type: ChatActionTypes.ADD_REACTION_OPTIMISTIC;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    tempId: string;
    content: string;
    user: Groupthink.UserResource;
  };
}

export interface AddReactionConfirmed {
  type: ChatActionTypes.ADD_REACTION_CONFIRMED;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    tempId: string;
    message: Groupthink.MessageResource;
  };
}

export interface AddReactionRevert {
  type: ChatActionTypes.ADD_REACTION_REVERT;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    tempId: string;
  };
}

export interface RemoveReactionOptimistic {
  type: ChatActionTypes.REMOVE_REACTION_OPTIMISTIC;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    content: string;
    user: Groupthink.UserResource;
  };
}

export interface RemoveReactionConfirmed {
  type: ChatActionTypes.REMOVE_REACTION_CONFIRMED;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
  };
}

export interface RemoveReactionRevert {
  type: ChatActionTypes.REMOVE_REACTION_REVERT;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    content: string;
    user: Groupthink.UserResource;
  };
}

export interface DeleteMessage {
  type: ChatActionTypes.DELETE_MESSAGE;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
  };
}

export interface EditMessage {
  type: ChatActionTypes.EDIT_MESSAGE;
  payload: {
    threadableId: string;
    threadId: string;
    messageId: string;
    content: string;
    updatedMessage: Groupthink.MessageResource;
  };
}

export type ChatAction =
  | SetThreadablesLoading
  | SetThreadablesValidating
  | SetThreadablesData
  | SetThreadablesError
  | DeleteThreadable
  | SetThreadsLoading
  | SetThreadsValidating
  | SetThreadsData
  | SetThreadsError
  | SetActiveThreadable
  | SetActiveThread
  | DeleteThread
  | MarkThreadAsRead
  | SetMessagesLoading
  | SetMessagesValidating
  | SetMessagesData
  | SetMessagesError
  | SendMessageOptimistic
  | SendMessageConfirmed
  | SendMessageRevert
  | HandleMessageSentEvent
  | HandleMessageReactedToEvent
  | DeleteMessage
  | EditMessage
  | AddReactionOptimistic
  | AddReactionConfirmed
  | AddReactionRevert
  | RemoveReactionOptimistic
  | RemoveReactionConfirmed
  | RemoveReactionRevert;

export const setThreadablesLoadingAction = (
  threadableType: string,
  isLoading: boolean
): SetThreadablesLoading => ({
  type: ChatActionTypes.SET_THREADABLES_LOADING,
  threadableType,
  isLoading,
});
export const setThreadablesValidatingAction = (
  threadableType: string,
  isValidating: boolean
): SetThreadablesValidating => ({
  type: ChatActionTypes.SET_THREADABLES_VALIDATING,
  threadableType,
  isValidating,
});
export const setThreadablesDataAction = (
  threadableType: string,
  threadables: (Groupthink.RoomResource | Groupthink.TaskResource | Groupthink.AgendaResource)[]
): SetThreadablesData => ({
  type: ChatActionTypes.SET_THREADABLES_DATA,
  threadableType,
  threadables,
});
export const setThreadablesErrorAction = (
  threadableType: string,
  error: Error
): SetThreadablesError => ({
  type: ChatActionTypes.SET_THREADABLES_ERROR,
  threadableType,
  error,
});

export const deleteThreadableAction = (
  threadableType: string,
  threadableId: string
): DeleteThreadable => ({
  type: ChatActionTypes.DELETE_THREADABLE,
  payload: { threadableType, threadableId },
});

export const setActiveThreadableAction = (
  threadableType: string,
  threadableId: string
): SetActiveThreadable => ({
  type: ChatActionTypes.SET_ACTIVE_THREADABLE,
  threadableType,
  threadableId,
});

export const setThreadsLoadingAction = (
  threadableId: string,
  isLoading: boolean
): SetThreadsLoading => ({
  type: ChatActionTypes.SET_THREADS_LOADING,
  threadableId,
  isLoading,
});
export const setThreadsValidatingAction = (
  threadableId: string,
  isValidating: boolean
): SetThreadsValidating => ({
  type: ChatActionTypes.SET_THREADS_VALIDATING,
  threadableId,
  isValidating,
});
export const setThreadsDataAction = (
  threadableId: string,
  threads: Groupthink.ThreadResource[],
  hasMorePages: boolean
): SetThreadsData => ({
  type: ChatActionTypes.SET_THREADS_DATA,
  threadableId,
  threads,
  hasMorePages,
});
export const setThreadsErrorAction = (threadableId: string, error: Error): SetThreadsError => ({
  type: ChatActionTypes.SET_THREADS_ERROR,
  threadableId,
  error,
});
export const setActiveThreadAction = (threadId: string | null): SetActiveThread => ({
  type: ChatActionTypes.SET_ACTIVE_THREAD,
  threadId,
});
export const markThreadAsReadAction = (
  threadableId: string,
  threadId: string,
  messageId: string
): MarkThreadAsRead => ({
  type: ChatActionTypes.MARK_THREAD_AS_READ,
  payload: { threadableId, threadId, messageId },
});

export const setMessagesLoadingAction = (
  threadId: string,
  isLoading: boolean
): SetMessagesLoading => ({
  type: ChatActionTypes.SET_MESSAGES_LOADING,
  threadId,
  isLoading,
});
export const setMessagesValidatingAction = (
  threadId: string,
  isValidating: boolean
): SetMessagesValidating => ({
  type: ChatActionTypes.SET_MESSAGES_VALIDATING,
  threadId,
  isValidating,
});
export const setMessagesDataAction = (
  threadId: string,
  messages: Groupthink.MessageResource[]
): SetMessagesData => ({
  type: ChatActionTypes.SET_MESSAGES_DATA,
  threadId,
  messages,
});
export const setMessagesErrorAction = (threadId: string, error: Error): SetMessagesError => ({
  type: ChatActionTypes.SET_MESSAGES_ERROR,
  threadId,
  error,
});

export const sendMessageOptimisticAction = (
  threadableId: string,
  threadId: string,
  tempId: string,
  content: string,
  attachments: Attachment[],
  user: Groupthink.UserResource
): SendMessageOptimistic => ({
  type: ChatActionTypes.SEND_MESSAGE_OPTIMISTIC,
  payload: { threadableId, threadId, tempId, content, attachments, user },
});
export const sendMessageConfirmedAction = (
  threadableId: string,
  threadId: string,
  tempId: string,
  message: Groupthink.MessageResource
): SendMessageConfirmed => ({
  type: ChatActionTypes.SEND_MESSAGE_CONFIRMED,
  payload: { threadableId, threadId, tempId, message },
});
export const sendMessageRevertAction = (
  threadableId: string,
  threadId: string,
  tempId: string
): SendMessageRevert => ({
  type: ChatActionTypes.SEND_MESSAGE_REVERT,
  payload: { threadableId, threadId, tempId },
});
export const handleMessageSentEventAction = (
  message: Groupthink.MessageResource,
  user: Groupthink.UserResource
): HandleMessageSentEvent => ({
  type: ChatActionTypes.HANDLE_MESSAGE_SENT_EVENT,
  payload: { message },
  user,
});
export const handleMessageReactedToEventAction = (
  message: Groupthink.MessageResource
): HandleMessageReactedToEvent => ({
  type: ChatActionTypes.HANDLE_MESSAGE_REACTED_TO_EVENT,
  payload: { message },
});

export const addReactionOptimisticAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  tempId: string,
  content: string,
  user: Groupthink.UserResource
): AddReactionOptimistic => ({
  type: ChatActionTypes.ADD_REACTION_OPTIMISTIC,
  payload: { threadableId, threadId, messageId, tempId, content, user },
});

export const addReactionConfirmedAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  tempId: string,
  message: Groupthink.MessageResource
): AddReactionConfirmed => ({
  type: ChatActionTypes.ADD_REACTION_CONFIRMED,
  payload: { threadableId, threadId, messageId, tempId, message },
});

export const addReactionRevertAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  tempId: string
): AddReactionRevert => ({
  type: ChatActionTypes.ADD_REACTION_REVERT,
  payload: { threadableId, threadId, messageId, tempId },
});

export const removeReactionOptimisticAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  content: string,
  user: Groupthink.UserResource
): RemoveReactionOptimistic => ({
  type: ChatActionTypes.REMOVE_REACTION_OPTIMISTIC,
  payload: { threadableId, threadId, messageId, content, user },
});

export const removeReactionConfirmedAction = (
  threadableId: string,
  threadId: string,
  messageId: string
): RemoveReactionConfirmed => ({
  type: ChatActionTypes.REMOVE_REACTION_CONFIRMED,
  payload: { threadableId, threadId, messageId },
});

export const removeReactionRevertAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  content: string,
  user: Groupthink.UserResource
): RemoveReactionRevert => ({
  type: ChatActionTypes.REMOVE_REACTION_REVERT,
  payload: { threadableId, threadId, messageId, content, user },
});

export const deleteMessageAction = (
  threadableId: string,
  threadId: string,
  messageId: string
): DeleteMessage => ({
  type: ChatActionTypes.DELETE_MESSAGE,
  payload: { threadableId, threadId, messageId },
});

export const editMessageAction = (
  threadableId: string,
  threadId: string,
  messageId: string,
  content: string,
  updatedMessage: Groupthink.MessageResource
): EditMessage => ({
  type: ChatActionTypes.EDIT_MESSAGE,
  payload: { threadableId, threadId, messageId, content, updatedMessage },
});

export const deleteThreadAction = (threadableId: string, threadId: string): DeleteThread => ({
  type: ChatActionTypes.DELETE_THREAD,
  payload: { threadableId, threadId },
});
